import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, Transition as _Transition, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-project-bottom-bar" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  key: 0,
  class: "gfu-project-mini-wizard-expandable__content-wrapper"
}
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = {
  key: 0,
  class: "_tac _pt-1 _mt-1"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  class: "_mt-3 _flex _gap-1"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "gfu-project-mini-wizard-expandable__pledge" }
const _hoisted_10 = {
  key: 1,
  class: "gfu-project-mini-wizard-item gfu-btn gfu-btn--block gfu-btn--thin gfu-btn--light-outline _fo _ttr",
  "data-qa": `mini-wizard-item:Empty`
}
const _hoisted_11 = { class: "gfu-btn__text _lhb" }
const _hoisted_12 = {
  key: 2,
  class: "gfu-project-mini-wizard-item gfu-btn gfu-btn--block gfu-btn--thin gfu-btn--light-outline _fo _ttr _mt-1",
  "data-qa": `mini-wizard-item:Empty`
}
const _hoisted_13 = { class: "gfu-btn__text _lhb" }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = {
  key: 5,
  class: "_tac _pt-1 _mt-1"
}
const _hoisted_16 = { class: "gfu-project-mini-wizard-expandable" }
const _hoisted_17 = {
  class: "_flexwrap _jc-sb _ai-c gfu-1of1 _ai-fs _mb-0",
  "data-qa": "mini-wizard-expandable-summary"
}
const _hoisted_18 = {
  class: "gfu-bt--b1",
  "data-qa": "mini-wizard-expandable-summary:Backer"
}
const _hoisted_19 = { class: "gfu-1of1 _flexbtwn _ai-c" }
const _hoisted_20 = { class: "gfu-bt--caption _ttu" }
const _hoisted_21 = {
  class: "gfu-project-mini-wizard__price _tc--white _mr-1",
  "data-qa": "mini-wizard-expandable-summary:AlreadyPledged"
}
const _hoisted_22 = {
  key: 0,
  class: "gfu-project-mini-wizard__caption _tc--white"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 1,
  class: "gfu-bt--caption gfu-1of1 _mb-1 _mt-1",
  "data-qa": "mini-wizard-expandable-summary:Text"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 2,
  class: "_flexcol"
}
const _hoisted_28 = {
  key: 0,
  class: "gfu-project-mini-wizard__caption"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_countdown_badge = _resolveComponent("countdown-badge")
  const _component_base_button = _resolveComponent("base-button")
  const _component_mini_wizard_items_content = _resolveComponent("mini-wizard-items-content")
  const _component_project_promo_item = _resolveComponent("project-promo-item")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_detect_overflow = _resolveComponent("detect-overflow")
  const _component_mini_wizard_expandable_implicit_edit_mode_content = _resolveComponent("mini-wizard-expandable-implicit-edit-mode-content")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_display_currency_price = _resolveComponent("display-currency-price")
  const _component_go_to_checkout = _resolveComponent("go-to-checkout")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.showMainExpandButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "gfu-project-mini-wizard-expandable gfu-project-mini-wizard-expandable__expand-button-container _mt-0 _px-2",
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.onToggleExpandClick && $options.onToggleExpandClick(...args)))
        }, [
          _createElementVNode("button", {
            "aria-label": _ctx.Resources.ProjectHome.MiniWizardExpandableShowDetailsLabel,
            class: "gfu-project-mini-wizard-expandable__expand-button gfu-btn gfu-btn--circle"
          }, [
            _createVNode(_component_base_icon, { name: "chevron-up" })
          ], 8 /* PROPS */, _hoisted_2),
          (_ctx.isCrowdfundingOvertimeActive)
            ? (_openBlock(), _createBlock(_component_countdown_badge, {
                key: 0,
                theme: "urgent",
                class: "_lhb _mb-0 _mr-0",
                "campaign-end": $options.campaignEndToDate
              }, null, 8 /* PROPS */, ["campaign-end"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_Transition, {
      name: "gfu-slide-up",
      onBeforeEnter: $options.beforeEnter,
      onAfterLeave: $options.afterLeave
    }, {
      default: _withCtx(() => [
        ($data.isExpanded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "gfu-project-mini-wizard-expandable gfu-project-mini-wizard-expandable__expand-button-container _mt-0 _px-2",
                onClick: _cache[1] || (_cache[1] = (...args) => ($options.onToggleExpandClick && $options.onToggleExpandClick(...args)))
              }, [
                _createElementVNode("button", {
                  "aria-label": _ctx.Resources.ProjectHome.MiniWizardExpandableHideDetailsLabel,
                  class: "gfu-project-mini-wizard-expandable__expand-button gfu-btn gfu-btn--circle"
                }, [
                  _createVNode(_component_base_icon, { name: "chevron-down" })
                ], 8 /* PROPS */, _hoisted_4),
                (_ctx.isCrowdfundingOvertimeActive)
                  ? (_openBlock(), _createBlock(_component_countdown_badge, {
                      key: 0,
                      class: "_lhb _mb-0 _mr-0",
                      theme: "urgent",
                      "campaign-end": $options.campaignEndToDate
                    }, null, 8 /* PROPS */, ["campaign-end"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createVNode(_component_detect_overflow, { class: "gfu-project-mini-wizard-expandable__content" }, {
                default: _withCtx(() => [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "gfu-project-mini-wizard-expandable__shadow" }, null, -1 /* CACHED */)),
                  ((_ctx.isPledgePlaced && !_ctx.hasSameItemsAsParent) || !_ctx.isPledgeEmpty)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("a", {
                          class: "gfu-link gfu-link--accent",
                          href: _ctx.currentPledge.cartDetailsUrl,
                          "data-qa": "mini-wizard-button:ManageYourPledge"
                        }, _toDisplayString($options.cartDetailsLabel), 9 /* TEXT, PROPS */, _hoisted_6)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isInProcessingPaymentMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_base_icon, { name: "circle-info" }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardProcessingPaymentInfo), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.isEditingPledge && _ctx.canEditPledge)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        disabled: _ctx.isProcessing,
                        class: "gfu-btn gfu-btn--soft gfu-btn--block gfu-btn--narrow gfu-btn--accent _mt-1",
                        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.onEditPledge && _ctx.onEditPledge(...args))),
                        "data-qa": "mini-wizard-expandable-summary:EditPledge"
                      }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardEditPledgeButton), 9 /* TEXT, PROPS */, _hoisted_8))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_9, [
                    (!_ctx.allItemsRemoved)
                      ? (_openBlock(), _createBlock(_component_mini_wizard_items_content, {
                          key: 0,
                          "buttons-theme": $options.miniWizardItemsContentButtonsTheme,
                          "currency-symbol": _ctx.currencySymbol,
                          "rewards-section": _ctx.rewardsSection,
                          "addons-section": _ctx.addonsSection,
                          "is-unmodified-pledge": _ctx.isUnmodifiedPledge,
                          "can-delete-items": _ctx.canDeleteItems,
                          "pledge-date": _ctx.pledgeDate,
                          "show-addons": !_ctx.isPledgeEmpty,
                          "show-delete-button": true,
                          "delete-method": _ctx.onDeleteItem,
                          "show-rewards": !_ctx.allChargeableItemsRemoved
                        }, _createSlots({
                          addMoreItemsButton: _withCtx(() => [
                            _createVNode(_component_base_button, {
                              theme: $options.miniWizardItemsContentButtonsTheme,
                              animation: $options.submitButtonAnimationType,
                              href: "",
                              display: "block",
                              class: "_mt-2",
                              onClick: _cache[5] || (_cache[5] = _withModifiers($event => ($options.onItemsListButtonClick({name: 'page-section', params: { section: _ctx.rewardsSection.urlName }})), ["prevent"])),
                              "data-qa": "mini-wizard-expandable-button:AddMoreItems"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_base_icon, {
                                  name: "plus",
                                  class: "gfu-btn__icon gfu-icon _fl"
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardAddMoreItemsButton), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["theme", "animation"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, [
                          (_ctx.rewardsSection)
                            ? {
                                name: "chooseRewardsButton",
                                fn: _withCtx(() => [
                                  _createVNode(_component_base_button, {
                                    tag: "a",
                                    href: "",
                                    theme: $options.miniWizardItemsContentButtonsTheme,
                                    animation: $options.submitButtonAnimationType,
                                    display: "block",
                                    onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($options.onItemsListButtonClick({name: 'page-section', params: { section: _ctx.rewardsSection.urlName }})), ["prevent"])),
                                    "data-qa": "mini-wizard-expandable-button:ChooseReward"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_base_icon, {
                                        name: "plus",
                                        class: "gfu-btn__icon gfu-icon _fl"
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardChooseRewardsButton), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["theme", "animation"])
                                ]),
                                key: "0"
                              }
                            : undefined,
                          (_ctx.addonsSection)
                            ? {
                                name: "chooseAddonsButton",
                                fn: _withCtx(() => [
                                  _createVNode(_component_base_button, {
                                    tag: "a",
                                    href: "",
                                    display: "block",
                                    theme: $options.miniWizardItemsContentButtonsTheme,
                                    animation: $options.submitButtonAnimationType,
                                    onClick: _cache[4] || (_cache[4] = _withModifiers($event => ($options.onItemsListButtonClick({name: 'page-section', params: { section: _ctx.addonsSection.urlName }})), ["prevent"])),
                                    "data-qa": "mini-wizard-expandable-button:ChooseAddons"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_base_icon, {
                                        name: "plus",
                                        class: "gfu-btn__icon gfu-icon _fl"
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardChooseAddonsButton), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["theme", "animation"])
                                ]),
                                key: "1"
                              }
                            : undefined
                        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["buttons-theme", "currency-symbol", "rewards-section", "addons-section", "is-unmodified-pledge", "can-delete-items", "pledge-date", "show-addons", "delete-method", "show-rewards"]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.allItemsRemoved)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardRemovedAllItemsText), 1 /* TEXT */)
                        ]))
                      : (_ctx.allChargeableItemsRemoved)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardRemovedPaidItemsText), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true),
                    (_ctx.promoItem)
                      ? (_openBlock(), _createBlock(_component_project_promo_item, {
                          key: 3,
                          class: "_mt-3 gfu-1of1 gfu-bt gfu-bt--caption",
                          "data-qa": "mini-wizard-expandable-project-promo-item"
                        }))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isPledgeImplicitEditMode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("a", {
                            href: "",
                            class: "gfu-btn gfu-btn--soft gfu-btn--block gfu-btn--narrow gfu-btn--primary _mt-2",
                            onClick: _cache[6] || (_cache[6] = _withModifiers($event => ($options.onItemsListButtonClick({name: 'page-section', params: { section: _ctx.rewardsSection.urlName }})), ["prevent"])),
                            "data-qa": "mini-wizard-expandable-button:AddMoreItems"
                          }, [
                            _createVNode(_component_base_icon, {
                              name: "plus",
                              class: "gfu-btn__icon gfu-icon _fl"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardAddMoreItemsButton), 1 /* TEXT */)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isUnfinishedOrder && _ctx.isEditingPledge)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("a", {
                            class: "gfu-link gfu-link--accent",
                            href: "",
                            onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => (_ctx.onRevertChanges && _ctx.onRevertChanges(...args)), ["prevent"])),
                            "data-qa": "mini-wizard-expandable-button:RevertChanges"
                          }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardRevertChangesButton), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
                ]),
                _: 1 /* STABLE */
              })
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onBeforeEnter", "onAfterLeave"]),
    (_ctx.isPledgeImplicitEditMode)
      ? (_openBlock(), _createBlock(_component_mini_wizard_expandable_implicit_edit_mode_content, _normalizeProps(_mergeProps({ key: 1 }, _ctx.$props)), null, 16 /* FULL_PROPS */))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["gfu-project-bottom-bar__content", [{ 'gfu-project-mini-wizard-expandable__summary gfu-project-mini-wizard-expandable__summary--compact': _ctx.isPledgePlaced,
                        'gfu-project-mini-wizard-expandable__summary--alt-background': _ctx.isEditingPledge,
                        'gfu-project-mini-wizard-expandable__summary--image': _ctx.isPledgePlaced && _ctx.isUnmodifiedPledge }]])
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (_ctx.isUnmodifiedPledge)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("strong", null, _toDisplayString($options.summaryLabel), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString($options.orderDetailsLabel), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$format(_ctx.pledge.totalValueConverted, 'C2', _ctx.pledge.currencySymbol)), 1 /* TEXT */),
                        (_ctx.hasTaxHandlingEnabled)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.taxesSummaryLabel), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      (_ctx.isInProcessingPaymentMode)
                        ? (_openBlock(), _createBlock(_component_tooltip, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_base_icon, { name: "circle-info" }),
                              _createElementVNode("span", null, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardProcessingPaymentLabel), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }))
                        : _createCommentVNode("v-if", true),
                      (_ctx.canResumePayment)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: _ctx.currentPledge.resumeOrderUrl,
                            class: "gfu-project-mini-wizard-expandable__cta gfu-btn gfu-btn--soft gfu-btn--narrow gfu-btn--light-transparent",
                            "data-qa": "mini-wizard-expandable-summary:ResumePayment"
                          }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardResumePaymentButton), 9 /* TEXT, PROPS */, _hoisted_23))
                        : (_ctx.canEditPledge)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              disabled: _ctx.isProcessing,
                              class: "gfu-btn gfu-btn--soft gfu-btn--transparent-inverse _px-5",
                              onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.onEditPledge && _ctx.onEditPledge(...args))),
                              "data-qa": "mini-wizard-expandable-summary:EditPledge"
                            }, _toDisplayString(_ctx.Resources.ProjectHome.MiniWizardEditPledgeShortButton), 9 /* TEXT, PROPS */, _hoisted_24))
                          : _createCommentVNode("v-if", true)
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : (_ctx.isEditingPledge)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_ctx.pledge.parentOrder)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_26, _toDisplayString($options.miniWizardPledgeModifiedText), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
              (!_ctx.isPledgePlaced || _ctx.isEditingPledge)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("span", {
                      class: _normalizeClass(['gfu-bt--caption _ttu', {'_tc--lighter' : !_ctx.isPledgePlaced}])
                    }, [
                      _createVNode(_component_tooltip, {
                        text: _ctx.Resources.Homepage.MiniWizardNoShippingTooltip
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, { name: "circle-info" })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["text"]),
                      _createTextVNode(" " + _toDisplayString($options.yourPledgeLabel), 1 /* TEXT */)
                    ], 2 /* CLASS */),
                    _createVNode(_component_display_currency_price, {
                      "effective-price": _ctx.pledge.totalValueConverted
                    }, {
                      "effective-price": _withCtx(({ effectivePrice }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(['gfu-project-mini-wizard__price _mr-1', { '_tc--inverse' : _ctx.isPledgePlaced }])
                        }, _toDisplayString(effectivePrice), 3 /* TEXT, CLASS */),
                        (_ctx.hasTaxHandlingEnabled)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.taxesSummaryLabel), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["effective-price"])
                  ]))
                : _createCommentVNode("v-if", true),
              ($options.canSubmit)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    (!_ctx.isUnmodifiedPledge)
                      ? (_openBlock(), _createBlock(_component_go_to_checkout, {
                          key: 0,
                          "continue-url": _ctx.currentPledge.checkoutUrl
                        }, {
                          default: _withCtx(({ onInvoke }) => [
                            _createVNode(_component_tooltip, {
                              enabled: !$options.canProceedToCheckout,
                              text: _ctx.currentPledge.canProceedToCheckoutValidationResult.message
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_base_button, {
                                  enabled: $options.canProceedToCheckout,
                                  theme: $options.submitButtonTheme,
                                  width: "narrow",
                                  class: "gfu-project-mini-wizard-expandable__cta",
                                  onClick: _withModifiers(onInvoke, ["stop","prevent"]),
                                  "data-qa": "mini-wizard-expandable-button:Pledge"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($options.submitLabel), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["enabled", "theme", "onClick"])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["enabled", "text"])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["continue-url"]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : ($options.canCancel)
                  ? (_openBlock(), _createBlock(_component_base_button, {
                      key: 4,
                      disabled: !_ctx.currentPledge.canCancelPledge,
                      theme: "accent",
                      width: "narrow",
                      class: "gfu-project-mini-wizard-expandable__cta",
                      onClick: _withModifiers(_ctx.onCancelPledge, ["stop","prevent"]),
                      "data-qa": "mini-wizard-expandable-button:CancelPledge"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardCancelPledgeButton), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled", "onClick"]))
                  : _createCommentVNode("v-if", true)
            ])
          ])
        ], 2 /* CLASS */))
  ]))
}